import CustomButton from "@/components/custom-button/custom-button"
import { Objective } from "@/types/objective/objective-type";
import { Modal, Typography } from "antd";
import { useState } from "react";
import { MissionTermsFormat } from "./style-component";

interface MissionTermsAndConditionsProps {
  objectives: Objective[];
  name: string;
}

const { Title } = Typography;

const MissionTermsAndConditions = ({ objectives, name }: MissionTermsAndConditionsProps) => {

  const { terms_and_conditions } = objectives[0].details;
  const [open, setOpen] = useState<boolean>();

  const handleOpen = () => {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  if(!terms_and_conditions) {
    return <></>
  }

  return (
    <>
      <CustomButton data-testid="mission-terms-and-conditions" variant="text" onClick={handleOpen} style={{textDecoration:"underline 2px", textUnderlineOffset: "0.5rem"}}>Conoce los Términos y Condiciones</CustomButton>
      <Modal
        open={open}
        footer={[]}
        onClose={handleClose}
        onCancel={handleClose}
      >
        <Title level={4}>Términos y Condiciones de la Misión "{name}"</Title>
        <MissionTermsFormat>
          {terms_and_conditions &&
            <ol>
              {terms_and_conditions.map((term) => {
                return <li key={term}>{term}</li>
              })}
            </ol>
          }
        </MissionTermsFormat>
      </Modal>
      <></>
    </>
  )
}

export default MissionTermsAndConditions;